var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkshopicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.875,
    height: 15.875,
    viewBox: "0 0 15.875 15.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.53 -0.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -280.067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.323,281.124a.8.8,0,0,0-.793.795v8.467a.8.8,0,0,0,.793.793H14.552a.8.8,0,0,0,.795-.793v-8.467a.8.8,0,0,0-.795-.795Z",
    fill: "#e7ebef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.493,281.124a.8.8,0,0,1,.795.8v7.938a.8.8,0,0,1-.795.793H1.323a.8.8,0,0,1-.793-.793v.529a.8.8,0,0,0,.793.793H14.552a.8.8,0,0,0,.795-.793v-8.467a.8.8,0,0,0-.795-.8Z",
    fill: "#dbe1e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.913,291.708a1.326,1.326,0,0,0-1.324,1.322v.266a1.323,1.323,0,0,0,2.646,0v-.266a1.325,1.325,0,0,0-1.322-1.322Z",
    fill: "#fdd5a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.022,291.708A1.325,1.325,0,0,0,12.7,293.03v.266a1.323,1.323,0,0,0,2.646,0v-.266A1.326,1.326,0,0,0,14.022,291.708Z",
    fill: "#fdd5a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.913,291.708a1.313,1.313,0,0,0-.53.113,1.324,1.324,0,0,1,.794,1.21v.266a1.324,1.324,0,0,1-.794,1.21,1.319,1.319,0,0,0,1.852-1.21v-.266a1.325,1.325,0,0,0-1.322-1.322Z",
    fill: "#fdcc93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.024,291.708a1.313,1.313,0,0,0-.53.113,1.324,1.324,0,0,1,.794,1.21v.266a1.324,1.324,0,0,1-.794,1.21,1.319,1.319,0,0,0,1.852-1.21v-.266a1.325,1.325,0,0,0-1.322-1.322Z",
    fill: "#fdcc93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.466,291.708a1.326,1.326,0,0,0-1.324,1.322v.266a1.323,1.323,0,0,0,2.646,0v-.266A1.325,1.325,0,0,0,8.466,291.708Z",
    fill: "#fdd5a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.466,291.708a1.313,1.313,0,0,0-.53.113,1.324,1.324,0,0,1,.794,1.21v.266a1.324,1.324,0,0,1-.794,1.21,1.319,1.319,0,0,0,1.852-1.21v-.266a1.325,1.325,0,0,0-1.322-1.322Z",
    fill: "#fdcc93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.852,282.183a.265.265,0,0,0-.266.266v7.408a.265.265,0,0,0,.266.264h12.17a.265.265,0,0,0,.266-.264v-7.408a.265.265,0,0,0-.266-.266Z",
    fill: "#68b1fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.118,294.089A1.591,1.591,0,0,0,.53,295.677v.529a.265.265,0,0,0,.266.266H5.028a.265.265,0,0,0,.266-.266v-.529a1.591,1.591,0,0,0-1.588-1.588Z",
    fill: "#fc6067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.261,294.089a1.591,1.591,0,0,1,1.588,1.588v.529a.265.265,0,0,1-.266.266H6.351a.265.265,0,0,1-.266-.266v-.529a1.591,1.591,0,0,1,1.588-1.588Z",
    fill: "#68b1fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.819,294.089a1.589,1.589,0,0,1,1.586,1.588v.529a.265.265,0,0,1-.264.266H11.909a.265.265,0,0,1-.266-.266v-.529a1.591,1.591,0,0,1,1.588-1.588Z",
    fill: "#59e78b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.525,295.943H6.351a.265.265,0,0,1-.266-.266v.529a.265.265,0,0,0,.266.266h4.232a.265.265,0,0,0,.266-.266v-.53a1.59,1.59,0,0,0-1.588-1.587H8.2a1.59,1.59,0,0,1,1.588,1.588.265.265,0,0,1-.266.266Z",
    fill: "#4fa4fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.081,295.943H11.907a.265.265,0,0,1-.266-.266v.529a.265.265,0,0,0,.266.266h4.232a.265.265,0,0,0,.266-.266v-.53a1.59,1.59,0,0,0-1.588-1.587H13.759a1.59,1.59,0,0,1,1.588,1.588.265.265,0,0,1-.266.266Z",
    fill: "#41e37a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.97,295.943H.8a.265.265,0,0,1-.266-.266v.529a.265.265,0,0,0,.266.266H5.028a.265.265,0,0,0,.266-.266v-.53a1.59,1.59,0,0,0-1.588-1.587H2.647a1.59,1.59,0,0,1,1.588,1.588.265.265,0,0,1-.266.266Z",
    fill: "#fb4f56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.853,282.183a.265.265,0,0,0-.266.266v7.408a.265.265,0,0,0,.266.264H2.911a.265.265,0,0,1-.266-.264v-6.879a.265.265,0,0,1,.266-.266H14.022a.265.265,0,0,1,.266.266v-.529a.265.265,0,0,0-.266-.266Z",
    fill: "#4fa4fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.731,280.6a.8.8,0,0,0-.793.793v4.232a.8.8,0,0,0,.793.8h.264v1.322a.265.265,0,0,0,.438.2l1.777-1.523h4.4a.8.8,0,0,0,.8-.8V281.39a.8.8,0,0,0-.8-.793Z",
    fill: "#fc6067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.848,282.183v2.646a.265.265,0,0,0,.4.225l2.117-1.322a.265.265,0,0,0,0-.449l-2.117-1.324a.264.264,0,0,0-.4.225Z",
    fill: "#e7ebef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.552,280.6a.8.8,0,0,1,.8.793v3.7a.8.8,0,0,1-.8.8H11.21l-1.777,1.523a.265.265,0,0,1-.438-.2v.529a.265.265,0,0,0,.438.2l1.777-1.523h4.4a.8.8,0,0,0,.8-.8V281.39a.8.8,0,0,0-.8-.793Z",
    fill: "#fb4f56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.233,288.006a1.589,1.589,0,0,0-1.588,1.585v.529H8.467v-.529a1.588,1.588,0,0,0-1.588-1.585Z",
    fill: "#fcbc60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.821,288.006a1.588,1.588,0,0,1,1.588,1.585v.529H8.467v-.529a1.588,1.588,0,0,0-1.588-1.585Z",
    fill: "#fbb04f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,286.947v1.322a.27.27,0,0,0,.006.06.99.99,0,0,0,.2.377,1.111,1.111,0,0,0,.85.356,1.106,1.106,0,0,0,.847-.356.991.991,0,0,0,.2-.377.261.261,0,0,0,.006-.06v-1.322Z",
    fill: "#fdd5a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,286.947v1.033a2.083,2.083,0,0,0,2.116,0v-1.034Z",
    fill: "#fdcc93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.97,285.093v1.059a1.587,1.587,0,1,0,3.174,0v-1.059Z",
    fill: "#fdd5a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.085,285.093v1.059a1.589,1.589,0,0,1-1.057,1.495,1.582,1.582,0,0,0,2.115-1.495v-1.059Z",
    fill: "#fdcc93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.292,283.242A1.591,1.591,0,0,0,3.7,284.83v.793a.265.265,0,0,0,.266.266h.793a3.377,3.377,0,0,0,1.549-.459l.381.38a.265.265,0,0,0,.188.079h.264a.265.265,0,0,0,.266-.266v-.793a1.591,1.591,0,0,0-1.588-1.588Z",
    fill: "#5a626e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.292,283.242a1.615,1.615,0,0,0-.265.024,1.59,1.59,0,0,1,1.323,1.564v.639l.342.341a.265.265,0,0,0,.188.079h.264a.265.265,0,0,0,.266-.266v-.793a1.591,1.591,0,0,0-1.588-1.588Z",
    fill: "#515663"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshopicon);
export default __webpack_public_path__ + "static/media/workshopicon.c2902ac0efd9c8e66ab54cf01c0becac.svg";
export { ForwardRef as ReactComponent };